// extracted by mini-css-extract-plugin
export var container = "period-module--container--2Z3dN";
export var desc = "period-module--desc--zq2+B";
export var image = "period-module--image--JRgRJ";
export var period = "period-module--period--SiqPx";
export var periodSection = "period-module--period-section--NN+qr";
export var title = "period-module--title--9ozLi";